<template>
  <div class="choice">
    <bread :list="list"></bread>
    <!--  -->
    <div>
      <div class="step flex text-ff justify-between text-center align-center">
        <div class="step1">
          <div class="step_img">1</div>
          <div class="text-12 text-1a">选择品牌</div>
        </div>
        <div class="line" style="background: #E3E3E3;"></div>
        <div class="step2">
          <div class="step_img">2</div>
          <div class="text-12 text-1a">上传资料</div>
        </div>
        <div class="line" style="background: #E3E3E3;"></div>
        <div class="step3">
          <div class="step_img">3</div>
          <div class="text-12 text-1a">完成</div>
        </div>
      </div>
      <!--  -->
      <div class="flex align-center text-14 justify-center">
        <div class="flex align-center margin-right-50">
          <div class="margin-right-10 word-all">品牌分类</div>
          <el-select
            class="margin-right-10"
            v-model="classId"
            placeholder="请选择"
            @change="classChange"
          >
            <el-option
              v-for="item in classList"
              :key="item.id"
              :label="item.type_name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            class="margin-right-10"
            v-if="classList_two"
            v-model="classId_two"
            placeholder="请选择"
            @change="twoChange"
          >
            <el-option
              v-for="item in classList_two"
              :key="item.id"
              :label="item.type_name"
              :value="item.id"
            ></el-option>
          </el-select>
          <!-- 三级 -->
          <el-select v-if="classList_three" v-model="classId_three" placeholder="请选择" @change="getList">
            <el-option
              v-for="item in classList_three"
              :key="item.id"
              :label="item.type_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="flex align-center margin-right-60">
          <div class="margin-right-10 word-all">品牌名称</div>
          <el-input v-model="keyword" placeholder="请输入" @keyup.enter.native="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </div>
        <!-- <div class="apply text-ff text-center poi" @click="search">搜索</div> -->
        <el-button class="btn1 word-all" type="primary" @click="go('brandAddNew')">提交品牌线索</el-button>
      </div>
      <!--  -->
      <div class="margin-tb-30">
        <!-- / -->
        <div v-if="data.data != undefined && data.data.length == 0">
          <img class="w-30p margin-auto" src="@/public/img/nolist.jpg" alt />
        </div>
        <ul class="flex flex-wrap item_ul">
          <li class="item_li text-content" v-for="(item,index) in data.data" :key="index">
            <div class="disable" v-if="item.add_not">
              <img src="@/public/img/yitianjia.png" alt />
            </div>
            <div class="item_li_li">
              <img :src="item.thumb?item.thumb:$nodata" alt />
            </div>
            <div class="padding-lr-15 padding-tb-10 flex justify-between align-center">
              <div class="flex-grow">
                <div class="text-14 text-33">{{item.brand_title}}</div>
                <div class="text-12 text-98 text-cut-one">{{item.content}}</div>
              </div>
              <i class="el-icon-circle-plus-outline" @click="testBrand(item.id)"></i>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <page @CurrentChangeFun="getCurrent" :pageMsg="data"></page>
    <!--  -->
    <div class="text-content margin-tb-20">
      <div class="text-14 text-33 margin-bottom-10">说明</div>
      <div class="text-12 text-66">如果系统品牌库没有您需要添加的品牌，请提交品牌线索，我们将在三个工作日内审核并上传您提交的品牌，谢谢！</div>
    </div>
  </div>
</template>

<script>
import bread from "../../../components/bread";
import page from "../../../components/page";
export default {
  components: {
    bread,
    page
  },
  data() {
    return {
      list: [
        {
          title: "信息管理"
        },
        {
          title: "品牌管理"
        },
        {
          title: "代理品牌"
        },
        {
          title: "申请代理品牌"
        }
      ],
      keyword: "",

      data: "",
      page: 1,
      classList: "", // yiji
      classList_two: "", // 二级分类
      classId: "",
      classId_two: "",

      classList_three: "",
      classId_three: ""
    };
  },
  mounted() {
    this.getClass();
    this.getList();
  },
  methods: {
    // 验证品牌
    testBrand(id) {
      this.$confirm("确认是否把该信息添加到我的代理品牌中!", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.post(this, "/home/verifybrandAdd", {
            token: window.localStorage.getItem("pc_token"),
            type: 2,
            brand_id: id
          }).then(res => {
            if (res.data.code == 0) {
              this.$router.push({
                name: "brandUploads",
                query: {
                  id: id
                }
              });
            }
          });
        })
        .catch(() => {});
    },
    // 获取分类
    getClass() {
      this.post(this, "/home/brandType", {
        token: window.localStorage.getItem("pc_token")
      }).then(res => {
        this.classList = res.data.data.yiji;
        this.classList.unshift({
          erji: [],
          id: 0,
          type_name: "全部分类"
        });
      });
    },
    // 级联二级
    classChange(e) {
      this.classId_two = "";
      this.classId_three = "";
      for (let i in this.classList) {
        if (e == this.classList[i].id && this.classList[i].erji.length > 0) {
          console.log(this.classList[i].erji)
          this.classList_two = this.classList[i].erji;
          this.classList_two.unshift({
            sanji: [],
            id: 0,
            type_name: "全部分类"
          });
          if (this.classList_two[1].id == 0) {
            this.classList_two.shift();
          }
          this.getList()
          return false;
        } else {
          this.classList_two = "";
          this.classList_three = "";
          this.getList()
        }
      }
    },
    // 级联三级
    twoChange(e) {
      this.classId_three = "";
      for (let i in this.classList_two) {
        if (
          e == this.classList_two[i].id &&
          this.classList_two[i].sanji.length > 0
        ) {
          this.classList_three = this.classList_two[i].sanji;
          this.classList_three.unshift({
            id: 0,
            type_name: "全部分类"
          });
          if (this.classList_three[1].id == 0) {
            this.classList_three.shift();
          }
          this.getList()
          return false;
        } else {
          this.classList_three = "";
          this.getList()
        }
      }
    },
    // 搜搜
    search() {
      this.page = 1;
      this.getSearch();
    },
    // 获取列表
    getSearch() {
      this.post(this, "/home/brandList", {
        token: window.localStorage.getItem("pc_token"),
        limit: 15,
        page: this.page,
        bradn_type_id:"",
        brand_title: this.keyword,
        type: 1
      }).then(res => {
        this.data = res.data.data;
      });
    },
    getList() {
      this.post(this, "/home/brandList", {
        token: window.localStorage.getItem("pc_token"),
        limit: 15,
        page: this.page,
        bradn_type_id:
          this.classId || this.classId_two || this.classId_three
            ? [this.classId, this.classId_two ? this.classId_two : 0, this.classId_three ? this.classId_three : 0].join(",")
            : "",
        brand_title: this.keyword,
        type: 1
      }).then(res => {
        this.data = res.data.data;
      });
    },
    getCurrent(val) {
      this.page = val;
      this.getList();
    },
    go(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style scoped>
.step {
  width: 430px;
  margin: 20px auto;
}
.step_img {
  width: 44px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  position: relative;
  margin: 0 auto 20px;
}
.step1 .step_img {
  background: url("../../../public/img/step1.png") no-repeat;
  background-size: 100% 100%;
}
.step2 .step_img {
  background-size: 100% 100% !important;
  background: url("../../../public/img/re_step1.png") no-repeat;
}
.step3 .step_img {
  width: 34px;
  background: url("../../../public/img/step2.png") no-repeat;
  background-size: 100% 100%;
}
.line {
  height: 1px;
  flex-grow: 1;
  background: #ff7b00;
  transform: translateY(-15px);
}
select,
input {
  width: 218px;
  height: 33px;
  border: 1px solid #cccccc;
  padding: 0 6px;
}
.apply {
  height: 30px;
  line-height: 30px;
  width: 118px;
  background: #ff7b00;
}
.item_li {
  width: 18%;
  margin-right: 2.5%;
  margin-bottom: 20px;
  border: 1px solid #e3e3e3;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}
.item_li:nth-of-type(5n) {
  margin-right: 0;
}
.item_li_li {
  width: 100%;
  height: 135px;
  min-height: 135px;
  max-height: 135px;
}
.item_li_li img {
  width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.el-icon-circle-plus-outline {
  font-size: 27px;
  color: #ff7700;
}
.disable {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}
.disable img {
  width: 100%;
  height: 100%;
  display: block;
}
.btn1 {
  width: 130px;
  border: none;
  background-color: #ff7c00;
  color: #fff;
  margin-right: 30px;
}
</style>

<style>
.choice .el-input-group__append {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  transform: translateX(10px);
  border-left: 1px solid #dcdfe6;
}
.choice .el-input-group--append .el-input__inner,
.choice .el-input-group__prepend {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.choice  .el-input-group{
  width: 250px;
}
</style>